module.exports = __webpack_public_path__ + "static/media/angle-down.4a0aa59c.svg";